module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fgAVN5/tc-custom/9780830898374.jpg?1696025161238",
      "alt": "This image is the cover for the book How to Give Away Your Faith, The IVP Signature Collection"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How to Give Away Your Faith, The IVP Signature Collection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"So you want to witness! I did too, but I didn't have a clue about how to do it without stubbing my toe in the process.\" So begins the book that has helped more than a million people give their faith to others. Paul Little's humor and down-to-earth approach help show how friendly and natural evangelism can really be. \"Impossible!\" you may say. \"I just don't know what I'd tell people. What if I can't answer their questions? What if they think I'm just strange?\" Paul Little has faced these sames fears and found effective and bibilcal ways to overcome them. Thoroughly revised by Marie Little and featuring a study guide for individuals or groups,"), _c('em', [_vm._v("How to Give Away Your Faith")]), _vm._v(" is as current as it is classic. Now more than ever, here is the book to excite you about giving away your faith.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul E. Little, James F. Nyquist, Leighton Ford\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Paul E. Little and his wife, Marie, worked for twenty-five years with InterVarsity Christian Fellowship. Until his death in 1975, Little was also associate professor of evangelism at Trinity Evangelical Divinity School in Deerfield, Illinois. He was the author of several books and articles, including "), _c('em', [_vm._v("Know Why You Believe.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0